import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
// import { getReportSetting, searchReportSetting } from '../../../redux/actions/reportSetting'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SearchSubprojectWidgets from '../../../widgets/projectMonitorRecord/SearchSubprojectWidgets'
import { getSubprojectAll } from '../../../redux/actions/SearchSubproject'

export default function SearchSubproject() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [projectCode, setProjectCode] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('load ProjectName projectId', projectId)

    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubprojectAll(5, 1)

      // setSchema(_schema)
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectReport>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

          <SearchSubprojectWidgets schema={schema} />
        </SidebarProposal>
      )}
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    form: {
      header: null,
      searchForm: {
        header: null,
        subProjectCode: {
          name: 'subProjectCode',
          label: 'รหัสโครงการย่อย',
          value: null,
        },
        projectName: {
          name: 'projectName',
          label: 'ชื่อโครงการ',
          value: null,
        },
        granteeSubProjectCode: {
          name: 'granteeSubProjectCode',
          label: 'ผู้รับทุนโครงการย่อย',
          value: null,
        },
        leaderManageName: {
          name: 'leaderManageName',
          label: 'หัวหน้าหน่วยจัดการ',
          value: null,
        },
        operatingArea: {
          options: [
            {
              disabled: false,
              label: 'เชียงราย',
              value: '0',
            },
            {
              disabled: false,
              label: 'เชียงใหม่',
              value: '1',
            },
          ],
          name: 'operatingArea',
          label: 'พื้นที่ดำเนินงาน',
          value: null,
        },
        region: {
          options: [
            {
              disabled: false,
              label: 'เหนือ',
              value: '0',
            },
            {
              disabled: false,
              label: 'ใต้',
              value: '1',
            },
          ],
          name: 'region',
          label: 'ภูมิภาค',
          value: null,
        },
        contractNo: {
          name: 'contractNo',
          label: 'เลขที่ข้อตกลง',
          value: null,
        },
        coordinatorSuportorName: {
          name: 'coordinatorSuportorName',
          label: 'ชื่อทีมสนับสนุนวิชาการ (พี่เลี้ยง)',
          value: null,
        },
      },
      data: {
        totalSize: 6,
        values: [
          // {
          //   id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
          //   subProjectCode: '67-10009-01',
          //   contractNo: '66-P1-0011',
          //   subProjectName: 'มหาวิทยาลัยสุขภาวะดีแห่งอนาคต',
          //   granteeSubProjectCode: 'นางสาวสุภัทรา เรืองวานิช',
          //   subProjecManager: 'นายโบวา เยล',
          //   subProjecStartEndDate: '01 ม.ค. 2567 - 30 ต.ค. 2567',
          //   projectCost: 100000,
          //   academicSupportTeam: 'นายสุภาพ ไทยแท้',
          //   headManagement: 'นายประสงค์ ดีเลิศ',
          //   evaluationTeam: 'นางสาวพจนา พุ่มเกตุ',
          //   Coordinator: 'นางสาววิภามาศ กำธรกิตติกุล',
          //   totalSize: 3,
          // },
          // {
          //   id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
          //   subProjectCode: '67-10009-02',
          //   contractNo: '66-P1-0012',
          //   subProjectName: 'การพัฒนาเทคโนโลยีสารสนเทศเพื่อการเกษตรครัวเรือน',
          //   granteeSubProjectCode: 'นางสาวสุภัทรา เรืองวานิช',
          //   subProjecManager: 'นายโบวา เยล',
          //   subProjecStartEndDate: '01 ม.ค. 2567 - 30 ต.ค. 2567',
          //   projectCost: 200000,
          //   academicSupportTeam: 'นางสาววรรณภา มีเนตรทิพย์',
          //   headManagement: 'นายประสงค์ ดีเลิศ',
          //   evaluationTeam: 'นางสาวพจนา พุ่มเกตุ',
          //   Coordinator: 'นางสาววิภามาศ กำธรกิตติกุล',
          //   totalSize: 3,
          // },
          // {
          //   id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
          //   subProjectCode: '67-10009-03',
          //   contractNo: '66-P1-0013',
          //   subProjectName: 'การพัฒนาศักยภาพผู้สูงอายุเพิ่มทักษะ ฟื้นฟูทักษะ ลดการพึ่งพาจากสังคม',
          //   granteeSubProjectCode: 'นางสาวสุภัทรา เรืองวานิช',
          //   subProjecManager: 'นายโบวา เยล',
          //   subProjecStartEndDate: '01 ม.ค. 2567 - 30 ต.ค. 2567',
          //   projectCost: 300000,
          //   academicSupportTeam: 'นางสาวชลณิชา อาษา',
          //   headManagement: 'นายประสงค์ ดีเลิศ',
          //   evaluationTeam: 'นางสาวพจนา พุ่มเกตุ',
          //   Coordinator: 'นางสาววิภามาศ กำธรกิตติกุล',
          //   totalSize: 3,
          // },
        ],
      },
    },
    header: 'ค้นหาข้อมูลโครงการย่อย',
    subHeader: null,
    disabled: true,
    isApprover: false,
  },
}
